/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import "./ViewOneMrf.css";
import ViewMrfPage from "../viewmrfpage/ViewMrfPage";
import pdficon from "../../../assests/word (2).png"
import wordicon from "../../../assests/word (1).png"
import arrow from "../../../assests/arrow_17004509.png"
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Form, Input, Button, Typography } from "antd"
import { FilePdfOutlined, FileWordOutlined } from "@ant-design/icons";
import CircularPercentage from "../../../components/CircularPercentage";
import LinkedInProfiles from "../../../components/LinkedInProfiles";


const { Text } = Typography;

export default function ViewOneMrf({ data }) {
    const { authData, backUrl } = useContext(AuthContext);
    const [mrfDetails, setMrfDetails] = useState(null);
    const [error, setError] = useState("");
    const [showData, setShowData] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [designation, setDesignations] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);

    const [taken, setTaken] = useState(0)

    const [updatedMrfStatus, setUpdatedMrfStatus] = useState({
        mrf_number: data,
        mrf_status: ""
    })

    const inputStyle = { width: '200px' };

    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setMrfDetails(res.data);
        } catch (err) {
            console.error("Fetch error:", err);
            setError("Failed to fetch MRF data.");
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
            console.log("workLocation", res.data.results)
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    }

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };


    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchTaken = async () => {
        const res = await axios.get(`${backUrl}/api/emp/candidates/?offerletter_status=ACCEPTED&requisition_id=${mrfDetails.id}`,
            {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
        setTaken(res.data.count)
        console.log(mrfDetails.id)
    }

    useEffect(() => {
        if (data) {
            fetchData();
            fetchDepartments();
            fetchDesignations();
            fetchOrganizations();
            fetchWorkLocation();
        }
    }, [data]);

    // 🔁 Auto-refresh every 30 seconds
    useEffect(() => {
        if (data && authData?.access) {
            const interval = setInterval(() => {
                fetchData();
            }, 30000); // 30 seconds

            return () => clearInterval(interval); // cleanup
        }
    }, [data, authData]);

    const getOrganizationName = (id) => organizationNames.find(o => o.id === id)?.name || "N/A";

    const handleClick = () => setShowData(false);

    const getDepartmentName = (id) => departments.find(dep => dep.id === id)?.name || id || "-";

    const getDesignationTitle = (id) => designation.find(des => des.id === id)?.name || id || "-";

    const handleUpdateMrf = async () => {
        const res = await axios.put(`${backUrl}/api/emp/manpowerrequisitions/update_status/`, updatedMrfStatus,
            {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        if (updatedMrfStatus.mrf_status === "Open") {
            toast.success("MRF status updated as Opened successfully!");
        }
        else if (updatedMrfStatus.mrf_status === "Close") {
            toast.error("MRF status updated as Closed successfully!");
        }
        else {
            toast.warning("MRF status updated as Hold successfully!");

        }

        console.log(res.data);
        fetchData()
    }


    useEffect(() => {
        if (mrfDetails?.id) {
            fetchTaken();
        }
    }, [mrfDetails]);



    return (
        <div className="view-container">
            <ToastContainer />
            {showData ? (
                <>
                    {error && <p className="text-danger">{error}</p>}
                    {!mrfDetails ? (
                        <p>Loading MRF Details...</p>
                    ) : (
                        <>
                            <div id="bread-container">
                                <a className="bread-anchor" id="bread-acr" onClick={handleClick}>Back to List</a>

                            </div>


                            <div className="d-flex justify-content-center align-items-center">
                                <section>
                                    <center><h5>Manpower Requisition Form</h5></center>
                                    <center>
                                        <h6 id={mrfDetails.mrf_status === 'Open' ? "status-indicator-green" : "status-indicator-gray"}>CURRENT STATUS -{" "}
                                            {mrfDetails.mrf_status === "Close" ? "Closed" : mrfDetails.mrf_status}</h6>
                                    </center>
                                </section>
                                <section className="mx-5">
                                    {/* <Text level={4}>Completion status</Text> */}
                                    <CircularPercentage vacancies={mrfDetails.no_of_vacancies} taken={taken} />

                                </section>
                            </div>





                            <div className="form container">
                                <Form.Item label="Organization">
                                    <Input value={getOrganizationName(mrfDetails.organisation)} readOnly />
                                </Form.Item>

                                <Form.Item label="Department">
                                    <Input value={getDepartmentName(mrfDetails.department)} readOnly />
                                </Form.Item>

                                <Form.Item label="Designation">
                                    <Input value={getDesignationTitle(mrfDetails.designation)} readOnly />
                                </Form.Item>

                                <Form.Item label="Site/Location">
                                    <Input value={mrfDetails.site_location || ""} readOnly />
                                </Form.Item>

                                <Form.Item label="Required By">
                                    <Input value={mrfDetails.required_by || ""} readOnly />
                                </Form.Item>

                                <Form.Item label="No. of Vacancies">
                                    <Input value={mrfDetails.no_of_vacancies || ""} readOnly />
                                </Form.Item>

                                <div>

                                </div>

                                {/* <div>
                                    <label>New/Replacement </label>
                                    <input type="text" value={mrfDetails.requisition_type || ""} readOnly />
                                </div> */}
                            </div>

                            <center>

                                <div id="center-area">
                                    <div id="requisition-type">
                                        <Form.Item label="Requisition Type">
                                            <Input value={mrfDetails.requisition_type || ""} style={inputStyle} readOnly />
                                        </Form.Item>
                                    </div>
                                    {
                                        mrfDetails.hr_approved && (
                                            <>
                                                <div id="download-area" className="mb-3">
                                                    <>
                                                        <Typography.Text>
                                                            Download
                                                        </Typography.Text>
                                                        <Button
                                                            type="link"
                                                            icon={<FilePdfOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=1`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.pdf';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('PDF download failed', error);
                                                                }
                                                            }}
                                                        />

                                                        <Button
                                                            type="link"
                                                            icon={<FileWordOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=2`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.docx';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('Word download failed', error);
                                                                }
                                                            }}
                                                        />
                                                    </>
                                                </div>


                                            </>
                                        )
                                    }
                                </div>
                            </center>

                            <hr />
                            <div className="form-2">
                                <div className="deployment-area">
                                    <h3>Deployment</h3>
                                    <label>Place Of Work </label>
                                    <input
                                        type="text"
                                        name="place_of_work"

                                        value={
                                            Array.isArray(mrfDetails.place_of_work)
                                                ? mrfDetails.place_of_work.join(", ")
                                                : ""
                                        }
                                        readOnly
                                    />

                                    {/* <label>Reporting To </label>
                                    <p>{mrfDetails.reporting_to || "-"}</p> */}

                                    <label>Job Description </label>
                                    <textarea name="job_description" value={mrfDetails.job_description || ""} readOnly />

                                    <a
                                     className="jd-anchor"
                                        href={mrfDetails.job_description_attachment}
                                        style={{
                                            background: 'transparent',
                                            color: 'black',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                    >
                                        JD Attachment : View File
                                    </a>

                                    <hr />
                                    <h5>Salary Range</h5>
                                    <label>From </label>
                                    <input type="number" name="from" value={mrfDetails.mrf_salary_from || ""} readOnly />
                                    <label>To </label>
                                    <input type="number" name="to" value={mrfDetails.mrf_salary_to || ""} readOnly />
                                </div>

                                <div className="requirement-profile">
                                    <h3>Requirement Profile</h3>
                                    <label>Qualification </label>
                                    <input type="text" name="qualification" value={mrfDetails.qualification || ""} readOnly />

                                    <label>Experience </label>
                                    <input type="text" name="experience" value={mrfDetails.experience || ""} readOnly />

                                    <label>Skill Sets </label>
                                    <textarea name="skill_sets" value={mrfDetails.skill_sets || ""} readOnly />

                                    <label>Any Other Requirements </label>
                                    <textarea name="other_requirements" value={mrfDetails.other_requirements || ""} readOnly />

                                    <label>Justification </label>
                                    <textarea name="justification" value={mrfDetails.justification || ""} readOnly />
                                </div>
                            </div>
                            <hr />

                            {mrfDetails.requisition_type === 'Replacement' && (
                                <>
                                    <h3>If Replacement</h3>
                                    <div className="replacement-form">
                                        <div className="form-group">
                                            <label>Name of the Leaving Employee </label>
                                            <input type="text" name="name_of_leaving_employee" value={mrfDetails.name_of_leaving_employee || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Date of Leaving </label>
                                            <input type="text" name="date_of_leaving" value={mrfDetails.date_of_leaving || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Reason for Leaving </label>
                                            <textarea name="reason_for_leaving" value={mrfDetails.reason_for_leaving || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Present Strength in the Category </label>
                                            <input type="text" name="present_dept_strength" value={mrfDetails.present_dept_strength || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Strength of the Function </label>
                                            <input type="text" name="strength_of_function" value={mrfDetails.strength_of_function || ""} readOnly />
                                        </div>

                                        <div className="form-group">
                                            <label>Remarks </label>
                                            <textarea name="replacement_remarks" value={mrfDetails.replacement_remarks || ""} readOnly />
                                        </div>
                                    </div>
                                </>
                            )}

                            <center>
                                <div className="mrf_status-panel">
                                    <label>Change MRF Status</label>
                                    <select name="mrf_status" value={updatedMrfStatus.mrf_status} onChange={(e) => {
                                        setUpdatedMrfStatus({ ...updatedMrfStatus, mrf_status: e.target.value })
                                    }}>
                                        <option value="">--Select Status--</option>
                                        <option value="Open">Open</option>
                                        <option value="On-Hold">Hold</option>
                                        <option value="Close">Close</option>
                                    </select>
                                    <br /><br />
                                    <Button style={{ backgroundColor: '#0e497b', color: 'white' }} onClick={handleUpdateMrf}>Submit</Button>
                                </div>
                            </center>

                            <LinkedInProfiles mrfNo={mrfDetails.mrf_number} backUrl={backUrl} authData={authData} />




                            {/* <div className="approval-area">
                                <button className="btn btn-warning me-2">Hold</button>
                                <button className="btn btn-danger">Close</button>
                            </div> */}

                        </>
                    )}
                </>
            ) : (
                <ViewMrfPage />
            )}
        </div>
    );
}
